import { PublicService, ObserverService, ListingModalService, ContentService, PortfolioService } from '@DavisDigital/davisdigitalfrontend.module';
import { FolderTypes } from '@DavisDigital/interfaces';

class PortfolioCardController {

	public portfolio: any;
	public portfolioType: string;

	public portfolioListing:any;
	public modalController:any;

	public title: string;
	public canEdit: boolean = false;
	public canAdmin: boolean = false;
	public imageUrl: string;
	public presentUrl: string;
	public editUrl: string;
	public slatwall:any;
	public folders:any;
	
	public sharedBy : string = "";
	public shareText : string = "";
	public administerAccountExists:boolean = false;
	
	public accountId: string;
	public superUser: boolean;
	public accountType: string;
	
	public pathToImage:string;
	
	// @ngInject
	constructor(
		public publicService: PublicService,
		public observerService: ObserverService,
		private contentService : ContentService,
		private portfolioService : PortfolioService,
		private listingModalService: ListingModalService
	) {}

	public $onInit = () => {
		this.mapMethodsFromPortfolio();

		this.observerService.attach( this.closeModals, 'duplicatePortfolioSuccess' );
	}
	
	public onShare = () => {
		if ( this.canEditPortfolio() ) {
	    	this.listingModalService.launchShareSettingModal(this.title,this.portfolio.portfolioID,'portfolio', "", this.notifyRefreshPortfolios, this.portfolio);
		}
	}
	
	public onEdit = () => {
		if ( this.canEditPortfolio() ) {
			window.location.href= this.editUrl;
		}
		
	}
	
	private canEditPortfolio = () => {
		if ( this.administerAccountExists ) {
			return true;
		}
		
		this.listingModalService.launchPortfolioAdministerShareModal(this.portfolio, this.notifyRefreshPortfolios);
		
		return false;
	}
	
	public onDuplicate = () => {
		if ( this.canEditPortfolio() ) {
		    this.listingModalService.launchDuplicateModal(null, this.portfolio, (success) => {
		        if( success ){ this.notifyRefreshPortfoliosAndFolders(); }
		    }, 'duplicate', this.accountType);
		}
	}
	
	public onMove = (folderType) => {
	    if ( this.canEditPortfolio() ) {
	    	this.listingModalService.launchMoveModal(this.title,this.portfolio.portfolioID, 'portfolio', folderType, this.notifyRefreshPortfoliosAndFolders);
	    }
	}

	public onDelete = () => {
		if ( this.canEditPortfolio() ) {
		    this.listingModalService.launchDeleteModal(
		        this.title,
		        this.portfolio.portfolioID,
		        'portfolio',
		        (confirmDelete) => {
		        	if(this.portfolioType == 'sharedPortfolios' || this.portfolioType == 'myStudentsPortfolios') {
		        		this.removeAccountAccess();
		        	} else {
		        		this.deletePortfolio();
		        	}
		        },
		        'portfolio',
        		this.portfolioType == 'sharedPortfolios'  || this.portfolioType == 'myStudentsPortfolios' ? true : false,
		    );
		}
	}

	public onExport = () => {
		if ( this.canEditPortfolio() ) {
			var anchor = document.createElement('a');
	        anchor.href = '?slatAction=davisdigital:api.exportPortfolios&apiData.portfolioID=' + this.portfolio.portfolioID + '&apiData.downloadNowFlag=true';
	        anchor.target = '_blank';
	        document.body.appendChild(anchor);
	        anchor.click();
	        document.body.removeChild(anchor);
		}
	}


	private mapMethodsFromPortfolio = () => {
		this.title = this.portfolio.title;
		this.presentUrl = `/portfolio/?portfolioID=${this.portfolio.portfolioID}&view=present`;
		this.editUrl = `/portfolio-editor/?portfolioID=${this.portfolio.portfolioID}&view=edit`;
		
		var accountAccess = false;
		if( this.portfolio.hasOwnProperty('accountAccess')) {
			if(this.portfolio.accountAccess.createdByAccount != null){
				this.sharedBy = this.portfolio.accountAccess.createdByAccount.firstName + " " + this.portfolio.accountAccess.createdByAccount.lastName + ", "+this.portfolio.accountAccess.createdByAccount.accountRole;
			}
			
			if(this.portfolio.accountAccess.accountAccessType == "accountAccessWrite") {
				accountAccess = true;
			}
			
			this.canAdmin = this.portfolio.accountAccess.accessShareType == 2;
		}
		
		this.canEdit = ( this.portfolio.portfolioType_systemCode === 'ptFeatured' && this.superUser ) ||
					   ( this.portfolio.account_accountID === this.accountId || this.superUser ) || (accountAccess);
		
		
		
		this.shareText = this.canAdmin ? "Can Administer" : this.canEdit ? "Can Edit" : "Can View";
		
		this.administerAccountExists = this.portfolio.administerAccountExists == undefined || this.portfolio.administerAccountExists == true;
	}
	
	private removeAccountAccess = () =>{
	    this.contentService
        .removeAccountAccessForShare(this.portfolio.portfolioID)
        .then( result => {
			if( result.successfulActions.length ) {
			    this.notifyRefreshPortfolios();
			}
		});
		//TODO: success/errors
	}
	
	
	private deletePortfolio = () =>{
	    this.portfolioService
        .deletePortfolio(this.portfolio.portfolioID)
        .then( result => {
			if( result.successfulActions.length ) {
			    this.notifyRefreshPortfoliosAndFolders();
			}
		});
		//TODO: success/errors
	}
	
	private notifyRefreshPortfolios = () => {
	    this.portfolioListing.getPortfolios(false,true);
	}
	
	private notifyRefreshPortfoliosAndFolders = () => {
	    this.portfolioListing.refreshFoldersAndPortfolios(true, true);
	}

	public closeModals = () => {
		$('.modal').modal('hide')
	}
}

class PortfolioCard {

	public restrict: string = 'EA';
	public scope:{};

	public bindToController: any = {
		portfolio: '=',
		portfolioType:'=',
		portfolioListing:'=',
		accountId:'@?',
		accountType:'@?',
		superUser:'=?',
		pathToImage:'@'
	};

	public controller = PortfolioCardController;
	public controllerAs = 'portfolioCard';

	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/portfolio-card.html';

	public static Factory() {
		return () => new this();
	}

}

export { PortfolioCard };
